import { inject, injectable, type interfaces } from 'inversify';
import type { BannerVariant, BannerContent } from '@/components/banner/Banner';
import { TYPES } from '@/engine/ioc';
import { BannerStore } from './Banner.store';

@injectable()
export class BannerService {
  private readonly _bannerStore: BannerStore;

  public constructor(@inject(TYPES.BannerStore as interfaces.ServiceIdentifier<BannerStore>) bannerStore: BannerStore) {
    this._bannerStore = bannerStore;
  }

  public showBanner({ variant, content }: { variant: BannerVariant; content: BannerContent }): void {
    this._bannerStore.showBanner(variant, content);
  }
}
